export const AddListIcon = () => (
  <svg fill={'#01875f'} width='24' height='24' viewBox='0 0 24 24'>
    <path d='M7 3H17C18.1045 3 19 3.8955 19 5V21L12 18L5 21L5.01075 5C5.01075 3.8955 5.8965 3 7 3ZM12 15.824L17 18V5H7V18L12 15.824ZM13 7V9H15V11H13V13H11V11H9V9H11V7H13Z'></path>
  </svg>
)
